export enum IncidenceAffair {
  DRIVER_APP = 'DRIVER_APP',
  ROADMAP = 'ROADMAP',
  ROUTE = 'ROUTE',
  PAX = 'PAX',
  VEHICLE = 'VEHICLE',
  DELAY = 'DELAY',
  EMERGENCY = 'EMERGENCY',
  OTHERS = 'OTHERS'
}
